export default [
  {
    path: '/admin/report/basic-salary-historys',
    name: 'basic-salary-history',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/payroll/basic-salary-history.vue')
  },
  {
    path: '/admin/report/nssf-reports',
    name: 'nssf-reports',
    component: () => import('@/pages/report/payroll/nssf-report.vue')
  },
  {
    path: '/admin/report/payslip',
    name: 'payslip',
    component: () => import('@/pages/report/payroll/Payslip/payslip-report.vue')
  },
  {
    path: '/admin/report/payroll-details',
    name: 'payroll-detail',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/payroll/payroll-detail.vue')
  },
  {
    path: '/admin/report/summary-pension-and-insurances',
    name: 'summary-pension-and-insurance',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/payroll/summary-pension-and-insurance/summary-pension-and-insurance.vue')
  }
]
